const PriceSearchDisclaimer = () => {
  return (
    <div
      data-testid="price-search-disclaimer"
      className="sticky top-0 bg-white z-[99] p-4 border-b-4 border-[#EEE] ml-[-1rem] mr-[-1rem]"
    >
      <div className="container content text-center">
        <p className="max-w-[800px] mx-auto">
          <b>ATENÇÃO: NÃO SÃO OBRIGATÓRIAS</b> as informações dos campos <b>SEM (*)</b> e podem ser preenchidas apenas
          se tiverem sido fornecidas única e exclusivamente de forma espontânea pelo cliente.
        </p>
      </div>
    </div>
  );
};

export default PriceSearchDisclaimer;
